export default (fractionalPrice) => {
  // in case we are getting something that's already a decimal price return it as a float
  if (!/\//.test(fractionalPrice.toString()) && !Number.isNaN(parseFloat(fractionalPrice))) {
    return parseFloat(fractionalPrice);
  }

  const priceParts = fractionalPrice.split('/').map((part) => parseInt(part, 10));
  return Math.round((1 + priceParts[0] / priceParts[1]) * 1000) / 1000;
};
